import ScoreSummaryTable from './ScoreSummaryTable';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import Title from 'lib/src/components/typography/Title';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import ActionButton from 'lib/src/components/button/ActionButton';
import { useParams } from 'react-router';
import { useState } from 'react';
import LinkModal from './LinkModal';
import DataCheck from 'lib/src/components/common/DataCheck';
import { isEmpty } from 'lib/src/utils/generic';
import useFetchChallengeScoreSummary from './_hooks/useFetchChallengeScoreSummary';
import { downloadFile } from '../../../../utils/generic';
import { useSelector } from 'react-redux';
import { getChallengesFetchError, getChallengesIsFetching } from '@selectors/challenges';
import { api } from 'lib/src/utils/api';

const ChallengeScoreSummary: React.FC = () => {
    const { challengeid: id } = useParams<{ id: string; challengeid: string }>();

    const [showLinkModal, setShowLinkModal] = useState<boolean>(false);

    const { scoreSummary, isFetching, fetchError } = useFetchChallengeScoreSummary(+id);

    const challengesIsFetching = useSelector(getChallengesIsFetching);
    const challengesFetchError = useSelector(getChallengesFetchError);
    return (
        <>
            <DataCheck
                dataExists={!isEmpty(scoreSummary)}
                isFetching={isFetching}
                error={fetchError}
            >
                <Breadcrumb items={[]} />
                <CreateHeader>
                    <Title>Challenge Score Summary</Title>
                </CreateHeader>
                <p>Here is the score summary for this challenge</p>
                <ButtonRow alignment="left">
                    <ActionButton onClick={() => setShowLinkModal(true)} color="blue" icon="share">
                        Share link
                    </ActionButton>
                    <ActionButton
                        onClick={async () => {
                            const res: { data: { s3URL: string } } = await api.get(
                                `admin/challenges/downloadpdf/${id}`,
                            );
                            downloadFile(
                                res.data.s3URL,
                                `${scoreSummary.challenge.name} - Challenge Score Summary.pdf`,
                            );
                        }}
                        color="grey"
                        icon="file-alt"
                        isPosting={challengesIsFetching}
                    >
                        Download PDF
                    </ActionButton>
                </ButtonRow>
                {challengesFetchError && (
                    <p className="form-generic-error">{challengesFetchError}</p>
                )}

                {!!scoreSummary && (
                    <ScoreSummaryTable
                        data={scoreSummary.assessmentSummaries}
                        isFetching={isFetching}
                    />
                )}

                {!!showLinkModal && (
                    <LinkModal
                        token={scoreSummary.token}
                        closeModal={() => setShowLinkModal(false)}
                    />
                )}
            </DataCheck>
        </>
    );
};

export default ChallengeScoreSummary;
